<svelte:options customElement={{
  tag: 'border-line',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * line：区切り線
   * パーツライブラリ準拠の mod-border / mod-borderTop / mod-borderBottom 構造
   * @prop {string} variant - 区切り線種別:
   *   'border1' (mod-border1), 'border2' (mod-border2),
   *   'top1' (mod-borderTop1), 'top2' (mod-borderTop2),
   *   'bottom1' (mod-borderBottom1), 'bottom2' (mod-borderBottom2),
   *   'gold' (mod-borderGold), 'gold-top' (mod-borderTopGold), 'gold-bottom' (mod-borderBottomGold)
   */
  export let variant = 'bottom2';

  const classMap = {
    border1: 'mod-border1',
    border2: 'mod-border2',
    top1: 'mod-borderTop1',
    top2: 'mod-borderTop2',
    bottom1: 'mod-borderBottom1',
    bottom2: 'mod-borderBottom2',
    gold: 'mod-borderGold',
    'gold-top': 'mod-borderTopGold',
    'gold-bottom': 'mod-borderBottomGold'
  };

  $: className = classMap[variant] || 'mod-borderBottom2';

  let wrapperEl;

  onMount(() => {
    const host = wrapperEl.parentElement;
    const nodesToMove = [];
    host.childNodes.forEach(node => {
      if (node !== wrapperEl) nodesToMove.push(node);
    });
    nodesToMove.forEach(node => wrapperEl.appendChild(node));
  });
</script>

<div class={className} bind:this={wrapperEl}></div>
